export const assessmentTemplate = [
  {
    _id: "botpressCUStandard",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "rlund3",
      createdDate: "2025-12-10T00:00:00Z",
      modifiedBy: null,
      modifiedDate: null,
      isActive: true,
    },
    omniData: {
      omniType: "botpressCUStandard",
      omniTypeVersion: 1,
      title: "Standard CU Questions",
      description:
        "This is a collection of the most common questions as asked by real users. This includes multiple phrasings of a question and ambiguous one word queries.",
      duration: "A little less than a bit",
      directions: "Do not close your browser window until the assessment is complete.",
      attribution: "Omniscia AI Team. All Rights Reserved.",
      validated: true,
      selfAssessment: true,
      startDate: null,
      completeDate: null,
      questions: [
        {
          omniID: "BOT001",
          numberText: "1",
          text: "Application",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT002",
          numberText: "2",
          text: "CD",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT003",
          numberText: "3",
          text: "Catfish",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT004",
          numberText: "4",
          text: "Checks",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT005",
          numberText: "5",
          text: "Disclosure",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT006",
          numberText: "6",
          text: "Donation Tool",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT007",
          numberText: "7",
          text: "Express loan",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT008",
          numberText: "8",
          text: "Fraud prevention",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT009",
          numberText: "9",
          text: "HELOC",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT010",
          numberText: "10",
          text: "Holiday loan",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT011",
          numberText: "11",
          text: "Rates",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT012",
          numberText: "12",
          text: "Rewards",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT013",
          numberText: "13",
          text: "Withdrawal limit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT014",
          numberText: "14",
          text: "app",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT015",
          numberText: "15",
          text: "balance transfer",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT016",
          numberText: "16",
          text: "board",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT017",
          numberText: "17",
          text: "certificates of deposit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT018",
          numberText: "18",
          text: "checking account",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT019",
          numberText: "19",
          text: "donation",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT020",
          numberText: "20",
          text: "grow with me",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT021",
          numberText: "21",
          text: "holiday",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT022",
          numberText: "22",
          text: "hr reliance",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT023",
          numberText: "23",
          text: "order checks",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT024",
          numberText: "24",
          text: "person to person",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT025",
          numberText: "25",
          text: "privacy policy",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT026",
          numberText: "26",
          text: "rate",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT027",
          numberText: "27",
          text: "reorder checks",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT028",
          numberText: "28",
          text: "student loans",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT029",
          numberText: "29",
          text: "tax forms",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT030",
          numberText: "30",
          text: "truth",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT031",
          numberText: "31",
          text: "1099-INT",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT032",
          numberText: "32",
          text: "ACH from savings",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT033",
          numberText: "33",
          text: "CD Rates",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT034",
          numberText: "34",
          text: "CDs",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT035",
          numberText: "35",
          text: "Careers",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT036",
          numberText: "36",
          text: "Cd",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT037",
          numberText: "37",
          text: "Certificate",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT038",
          numberText: "38",
          text: "Certificate of deposit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT039",
          numberText: "39",
          text: "Certificate of deposit rates",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT040",
          numberText: "40",
          text: "Certificate rates",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT041",
          numberText: "41",
          text: "Certificates of Deposit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT042",
          numberText: "42",
          text: "Check fraud",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT043",
          numberText: "43",
          text: "Credit card application",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT044",
          numberText: "44",
          text: "Credit card authorization",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT045",
          numberText: "45",
          text: "Deposit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT046",
          numberText: "46",
          text: "Fees",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT047",
          numberText: "47",
          text: "Harrisonburg",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT048",
          numberText: "48",
          text: "High yield savings",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT049",
          numberText: "49",
          text: "Skip",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT050",
          numberText: "50",
          text: "Skip a payment",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT051",
          numberText: "51",
          text: "Swift code",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT052",
          numberText: "52",
          text: "Wire transfer",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT053",
          numberText: "53",
          text: "Wire transfer fee",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT054",
          numberText: "54",
          text: "analysis",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT055",
          numberText: "55",
          text: "appreciation",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT056",
          numberText: "56",
          text: "approval to transfer money",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT057",
          numberText: "57",
          text: "auto loan",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT058",
          numberText: "58",
          text: "blog",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT059",
          numberText: "59",
          text: "business money market",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT060",
          numberText: "60",
          text: "calendar",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT061",
          numberText: "61",
          text: "care",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT062",
          numberText: "62",
          text: "certificate special",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT063",
          numberText: "63",
          text: "certificates",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT064",
          numberText: "64",
          text: "change password",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT065",
          numberText: "65",
          text: "checks",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT066",
          numberText: "66",
          text: "close account",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT067",
          numberText: "67",
          text: "coloring contest",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT068",
          numberText: "68",
          text: "credit card app",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT069",
          numberText: "69",
          text: "current interest rate on home equity LOC",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT070",
          numberText: "70",
          text: "debit card requirements",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT071",
          numberText: "71",
          text: "deposit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT072",
          numberText: "72",
          text: "digital wallet",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT073",
          numberText: "73",
          text: "enroll online",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT074",
          numberText: "74",
          text: "express loan",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT075",
          numberText: "75",
          text: "financial advisors",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT076",
          numberText: "76",
          text: "find an atm",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT077",
          numberText: "77",
          text: "free",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT078",
          numberText: "78",
          text: "good grades",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT079",
          numberText: "79",
          text: "how to find account number on check",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT080",
          numberText: "80",
          text: "jobs",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT081",
          numberText: "81",
          text: "leadership",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT082",
          numberText: "82",
          text: "log in",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT083",
          numberText: "83",
          text: "members title",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT084",
          numberText: "84",
          text: "modernfi",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT085",
          numberText: "85",
          text: "money management",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT086",
          numberText: "86",
          text: "money order",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT087",
          numberText: "87",
          text: "mutual funds",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT088",
          numberText: "88",
          text: "notary",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT089",
          numberText: "89",
          text: "report card, child",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT090",
          numberText: "90",
          text: "sign in",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT091",
          numberText: "91",
          text: "switch kit",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT092",
          numberText: "92",
          text: "tax form",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT093",
          numberText: "93",
          text: "transfer funds",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT094",
          numberText: "94",
          text: "where does overdraft come from",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT095",
          numberText: "95",
          text: "wire transfer",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "BOT096",
          numberText: "96",
          text: "youth saving",
          subText: "",
          helpText: "Please Wait...",
          multiSelectText: "false",
          instructions: "Please Wait...",
          displayType: "questionForBotpress",
          answerOptions: [],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: {
        finalResult: null,
      },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "botpressCUStandard",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
